// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__0tu1g","loading":"HW14_loading__epHls"};